/* fabri-preadd.js — Agrega "extras" al carrito justo antes que el producto principal.
   Lo usan el complemento de archivos digitales (fabri-archivos.js) y el adaptador de
   enchufe (fabri-enchufe.js). Cada uno registra una función en window.FabriPreAdd que
   devuelve lo que hay que agregar: [{ id, quantity, unico }]  (unico = no repetir si ya
   está en el carrito). Luego se deja que el tema agregue el producto como siempre, así el
   carrito lateral se refresca con todo junto.
   Se engancha en `window` en fase de captura porque el tema escucha los submit en
   `document` (captura): window corre antes y permite pausar el envío un instante. */
(function () {
  window.FabriPreAdd = window.FabriPreAdd || [];
  if (window.__fabriPreAdd) return;
  window.__fabriPreAdd = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var json = { 'Content-Type': 'application/json', Accept: 'application/json' };

  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || form.getAttribute('data-type') !== 'add-to-cart-form') return;

    // Segundo envío (el nuestro): dejar pasar al tema
    if (form.dataset.fabriPass === '1') {
      delete form.dataset.fabriPass;
      return;
    }

    var scope = form.closest('.shopify-section') || document.body;
    var extras = [];
    window.FabriPreAdd.forEach(function (fn) {
      try { (fn(form, scope) || []).forEach(function (x) { if (x && x.id) extras.push(x); }); }
      catch (err) { console.warn('[fabri-preadd]', err); }
    });
    if (!extras.length) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    var submitter = e.submitter && e.submitter.form === form ? e.submitter : undefined;
    scope.classList.add('fabri-busy');

    var necesitaCarrito = extras.some(function (x) { return x.unico; });
    (necesitaCarrito
      ? fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      : Promise.resolve({ items: [] }))
      .then(function (cart) {
        var enCarrito = (cart.items || []).map(function (i) { return i.variant_id; });
        var items = extras
          .filter(function (x) { return !(x.unico && enCarrito.indexOf(Number(x.id)) !== -1); })
          .map(function (x) { return { id: Number(x.id), quantity: x.quantity || 1 }; });
        if (!items.length) return;
        return fetch(root + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: items }) });
      })
      .catch(function (err) { console.warn('[fabri-preadd]', err); })
      .then(function () {
        scope.classList.remove('fabri-busy');
        form.dataset.fabriPass = '1';
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter);
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
  }, true);
})();
